import { REDUX_ACTIONS, ERROR_STRINGS } from './constants';

const initialState = {
  hasError: false,
  titleText: ERROR_STRINGS.uhOh,
  secondaryText: ERROR_STRINGS.theresBeenAnError,
  showGamesButton: true,
  showHomeButton: true,
  forceLogout: false,
  errorName: 'Error',
  errorMessage: '',
  category: 'javascript',
  metricId: 'javascript',
};

const globalErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.RESET_AQUA_ERROR: {
      return {
        ...initialState,
      };
    }
    case REDUX_ACTIONS.THROW_CUSTOM_AQUA_ERROR: {
      return {
        ...state,
        ...action.payload,
        hasError: true,
      };
    }
    case REDUX_ACTIONS.SET_IS_SHOWING_ERROR_SCREEN: {
      return {
        ...state,
        hasError: action.payload,
      };
    }
    default:
      return state;
  }
};

export default globalErrorReducer;
